export default __webpack_public_path__ + "static/media/white-bg-right.8bd769cd.PNG";